var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n        fill-rule: evenodd;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.3,27.9h-12.9c-2.2,0-4,1.9-3.8,4.2.2,2,2,3.4,3.9,3.4h7.4l-28.7,28.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0l28.7-28.7v7.5c0,2.2,1.9,4,4.2,3.8,2-.2,3.4-2,3.4-3.9v-12.8c0-4.2-3.4-7.6-7.6-7.6h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeArrow);
export default __webpack_public_path__ + "static/media/acae_arrow.ca024423.svg";
export { ForwardRef as ReactComponent };